import { render, staticRenderFns } from "./ReleaseInfo.vue?vue&type=template&id=08e16ee6"
import script from "./ReleaseInfo.vue?vue&type=script&lang=ts"
export * from "./ReleaseInfo.vue?vue&type=script&lang=ts"
import style0 from "./ReleaseInfo.vue?vue&type=style&index=0&id=08e16ee6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports